<script setup>
/**
 * Reports
 * This component acts as a router for different report types based on the current sitename.
 * It conditionally renders specific report components (BigBrandBedsReports, OdpReports, PrintGiftsReports)
 * depending on the detected sitename.
 */
import { computed, getCurrentInstance } from 'vue';
import BigBrandBedsReports from './BigBrandBedsReports.vue';
import OdpReports from './OdpReports.vue';
import PrintGiftsReports from './PrintGiftsReports.vue';

const { proxy } = getCurrentInstance();
const store = proxy.$store;

const sitename = computed(() => store.state.sitename);

const isBigBrandBeds = computed(() => sitename.value.indexOf('bigbrandbeds') === 0);
const isOdp = computed(() => sitename.value.indexOf('outdoorsproject') === 0);
const isPrintGifts = computed(() => sitename.value.indexOf('printgifts') === 0);
</script>

<template>
    <div>
        <BigBrandBedsReports v-if="isBigBrandBeds"/>
        <OdpReports v-if="isOdp"/>
        <PrintGiftsReports v-if="isPrintGifts"/>
    </div>
</template>